<template>
  <div>
        <loading v-model="loading"
                 :active="loading"
                 :can-cancel="false"
                 :on-cancel="onCancel"
                 :is-full-page="true"/>
    <div class="card z-depth-5 p-3">
      <FullCalendar
          ref="fullCalendar"
         :options='calendarOptions'
      >
        <template v-slot:eventContent='arg'>
          <b>{{ arg.timeText }}</b>
          <i>{{ arg.event.title }}</i>
        </template>
      </FullCalendar>
    </div>
    
    <mdb-container>
      <mdb-modal size="lg" :show="showCreateModal" removeBackdrop centered scrollable>
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showCreateModal = false">Close</button>
          <mdb-modal-body>
              <div class="card z-depth-5 p-3">
                  <h4 class="text-center font-weight-bold py-3">Create Lesson</h4>
                  <div>
                      <!-- Default form login -->
                      <form class="border border-light p-5">
                          <div class="row">
                              <div class="form-group col-md-12">
                                  <label>Title</label>
                                  <input type="text" v-model="creatingLesson.title" class="form-control mb-4" placeholder="Title">
                              </div>
                              <div class="form-group col-md-12">
                                  <label>{{startTime}} ~ {{endTime}}</label>
                                  <select v-model="creatingLesson.dateType" class="form-control mb-4">
                                    <option value="once">Once</option>
                                    <option value="weekly">Weekly</option>
                                  </select>                              
                              </div>
                              <div class="form-group col-md-12"  v-if="creatingLesson.dateType=='weekly'">
                                  <label>End Date</label>
                                  <input type="datetime-local" v-model="creatingLesson.endDate" class="form-control mb-4" placeholder="Please select a date">                          
                              </div>
                              <div class="form-group col-md-12">
                                  <label>Description</label>
                                  <ckeditor v-model="creatingLesson.description" :editor="editor" @ready="onReady"></ckeditor>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Group</label>
                                  <select v-model="creatingLesson.group" class="form-control mb-4">
                                    <option value="">Please select a group</option>
                                    <option v-for="item in 1000" :value="item" :key="item">Group {{item}}</option>
                                  </select>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Lesson Type</label>
                                  <select v-model="creatingLesson.lessonType" class="form-control mb-4">
                                    <option value="place">Place Lesson</option>
                                    <option value="online">Online Lesson</option>
                                  </select>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Status</label>
                                  <select v-model="creatingLesson.status" class="form-control mb-4">
                                    <option value="active">Active</option>
                                    <option value="disable">Disable</option>
                                  </select>
                              </div>
                          </div>

                          <!-- Sign in button -->
                          <button class="btn btn-info btn-block my-4" @click.prevent="createLesson()">Create Lesson</button>

                      </form>
                      <!-- Default form login -->
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showCreateModal = false">Close</button>
              </div>
          </mdb-modal-body>
      </mdb-modal>
      <mdb-modal size="lg" :show="showEditModal" removeBackdrop centered scrollable>
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showEditModal = false; showViewModal = true;">Close</button>
          <mdb-modal-body>
              <div class="card z-depth-5 p-3">
                  <h4 class="text-center font-weight-bold py-3">Edit Lesson</h4>
                  <div>
                      <!-- Default form login -->
                      <form class="border border-light p-5">
                          <div class="row">
                              <div class="form-group col-md-12">
                                  <label>Title</label>
                                  <input type="text" v-model="updatingRoom.title" class="form-control mb-4" placeholder="Title">
                              </div>
                              <div class="form-group col-md-12">
                                  <label>Description</label>
                                  <ckeditor v-model="updatingRoom.description" :editor="editor" @ready="onReady"></ckeditor>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Group</label>
                                  <select v-model="updatingRoom.group" class="form-control mb-4">
                                    <option value="">Please select a group</option>
                                    <option v-for="item in 1000" :value="item" :key="item">Group {{item}}</option>
                                  </select>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Lesson Type</label>
                                  <select v-model="updatingRoom.lessonType" class="form-control mb-4">
                                    <option value="place">Place Lesson</option>
                                    <option value="online">Online Lesson</option>
                                  </select>
                              </div>
                              <div class="form-group col-md-6">
                                  <label>Status</label>
                                  <select v-model="updatingRoom.status" class="form-control mb-4">
                                    <option value="active">Active</option>
                                    <option value="disable">Disable</option>
                                  </select>
                              </div>
                          </div>

                          <p>{{startTime}} ~ {{endTime}}</p>

                          <!-- Sign in button -->
                          <button class="btn btn-info btn-block my-4" @click.prevent="updateLesson()">Update Lesson</button>

                      </form>
                      <!-- Default form login -->
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showEditModal = false; showViewModal = true; ">Close</button>
              </div>
          </mdb-modal-body>
      </mdb-modal>
      <mdb-modal size="lg" class="videoConferencing" :show="showViewModal" removeBackdrop centered scrollable>
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showViewModal = false">Close</button>
          <mdb-modal-body>
              <div class="card z-depth-5 p-3">
                  <h4 class="text-center font-weight-bold py-3">{{updatingRoom.title}}</h4>
                  <b>Group {{updatingRoom.group}}</b>
                  <p>{{startTime}} ~ {{endTime}}</p>
                  <button type="button" v-if="updatingRoom.lessonType == 'online'" class="btn btn-warning btn-sm" @click="showViewModal = false; showMeetModal = true"><i class="fa fa-video"/> Video Conference</button>
                  <div>
                      <div class="border border-light p-5">
                          <div class="row">
                              <div class="col-md-12">
                                  <div v-html="updatingRoom.description"/> 
                              </div>                              
                          </div>
                      </div>
                      <!-- Default form login -->
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click.prevent="deleteLesson()">Delete</button>
                  <button type="button" class="btn btn-info btn-sm" data-dismiss="modal" @click="showViewModal = false; showEditModal = true">Edit</button>
              </div>
          </mdb-modal-body>
      </mdb-modal>
      <mdb-modal :show="showMeetModal" removeBackdrop fullHeight position="top">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showMeetModal = false">CLose Video Conferencing</button>
          <mdb-modal-body>
              <h4 class="text-center font-weight-bold py-3">{{updatingRoom.title}}</h4>
              <div class="videoConferencing">
                <vue-jitsi-meet
                                    ref="jitsiRef"
                                    domain="meet.jit.si"
                                    :options="jitsiOptions"
                                  ></vue-jitsi-meet>
              </div>
              <div class="modal-footer">
                  <!-- <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showCreateModal = false">Delete</button> -->
                  <!-- <button type="button" class="btn btn-info btn-sm" data-dismiss="modal" @click="showViewModal = false; showEditModal = true">Edit</button> -->
              </div>
          </mdb-modal-body>
      </mdb-modal>
    </mdb-container>

  </div>
</template>
<script>
import axios from "axios";
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { formatDate } from "@fullcalendar/core";
import { JitsiMeet } from '@mycure/vue-jitsi-meet';

import {
    mdbContainer,
    mdbModal,
    mdbModalBody
} from 'mdbvue';

export default {
  name: "TeacherClass",
  components: {
    FullCalendar,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    Loading,
    VueJitsiMeet: JitsiMeet
  },
  data() {
    return {
      timer: null,
      classroom: {},
      updatingRoom: {},
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      teacherName: localStorage.getItem("teacherName"),
      loading: true,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "timeGridWeek,listWeek",
        },
        initialView: 'timeGridWeek',
        themeSystem: "bootstrap",
        events: [],
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: true,
        selectable: true,
        selectMirror: true,
        allDaySlot: false,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventChange: this.handleEventsChange,
        datesSet: this.handleMonthChange,
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      editor: DecoupledEditor,
      currentEvents: [],
      newEventData: {},
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showMeetModal: false,
      creatingLesson : {
        title: "",
        group: "",
        lessonType: "place",
        age: "runner",
        startTime: "",
        endTime: "",
        description: "",
        status: "active",
        dateType: "once",
        endDate: "",
      },
      startTime: "",
      endTime: "",
      lastStartDate: "",
      lastEndDate: ""
    };
  },

  methods: {

    handleDateSelect(selectInfo) {
      console.log(selectInfo.startStr);
      console.log(selectInfo.endStr);
      this.newEventData = selectInfo;

      this.creatingLesson = {
        title: "",
        group: "",
        lessonType: "place",
        age: "runner",
        startTime: "",
        endTime: "",
        description: "",
        status: "active",
        teacher: "",
        dateType: "once",
        endDate: ""
      };

      this.creatingLesson.startTime = selectInfo.startStr;
      this.creatingLesson.endTime = selectInfo.endStr;

      this.startTime = formatDate(selectInfo.startStr, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      });

      this.endTime = formatDate(selectInfo.endStr, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });

      this.showCreateModal = true;

      let calendarApi = selectInfo.view.calendar;
      calendarApi.unselect() // clear date selection

    },
    
    handleEventClick(clickInfo) {
      console.log(clickInfo.event.id);
      this.updatingRoom = this.classroom[clickInfo.event.id];
      this.startTime = formatDate(this.updatingRoom.startTime, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',

      });

      this.endTime = formatDate(this.updatingRoom.endTime, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
      this.showViewModal = true;
    },

    handleEventsChange(event) {
      this.updatingRoom = this.classroom[event.event.id];
      this.updatingRoom.startTime = event.event.startStr;
      this.updatingRoom.endTime = event.event.endStr;
      this.updateLesson();
    },

    createLesson() {
      console.log(this.creatingLesson);

      if(this.creatingLesson.title == "") {
        this.$toast.open({
          message: "Error: Please input title",
          type: "error",
        });
        return;
      }

      if(this.creatingLesson.group == "") {
        this.$toast.open({
          message: "Error: Please select group",
          type: "error",
        });
        return;
      }

      if(this.creatingLesson.dateType == "weekly") {
        if(this.creatingLesson.endDate == "") {
          this.$toast.open({
            message: "Error: Please select end date",
            type: "error",
          });
          return;
        } else {
          let endDate = new Date(this.creatingLesson.endDate);
          let today = new Date();

          console.log(endDate.getTime(), today.getTime());

          if(endDate.getTime() <= today.getTime()) {
            this.$toast.open({
              message: "Error: Please select correct end date",
              type: "error",
            });
            return;
          }
        }
      }

      this.showCreateModal = false;

      let endDate = new Date(this.creatingLesson.endDate);
      this.creatingLesson.endDate = endDate.getTime();

      this.loading = true;

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };

      this.creatingLesson.teacher =  this.fastTeacherId;

      axios
      .post(
        this.$apiURI + "/classroom/create",
        this.creatingLesson,
        config
      )
      .then((response) => {

        this.loading = false;

        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          console.log("success");
          this.classroom[response.data.data._id] = response.data.data;
          this.calendarOptions.events = [
            ...this.calendarOptions.events,
            {
              id: response.data.data._id,
              title: response.data.data.title,
              start: response.data.data.startTime,
              end: response.data.data.endTime,
            }
          ];

          console.log(this.calendarOptions.events);
        }
      })
      .catch((error) => {
        this.loading = false;

        // eslint-disable-next-line no-console
        console.log(error);
        if (error.response) {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        } else {
          this.$toast.open({
            message: "Network/Server Error Please Reload Page and Try Again ",
            type: "error",
          });
        }
      });

    },

    deleteLesson() {
      if(confirm("Are you sure?") === true) {
        this.showViewModal = false;
        this.loading = true;

        const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };
        
        axios
        .post(
          this.$apiURI + "/classroom/" + this.updatingRoom.slug + "/delete",
          {},
          config
        )
        .then((response) => {
          this.loading = false;

          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            console.log("success");
            this.$toast.open({
              message: "Success : " + response.data.data.message,
              type: "success",
            });
            delete this.classroom[this.updatingRoom._id];
            this.calendarOptions.events = [];
            for (const [key, item] of Object.entries(this.classroom)) {
              console.log(key);
              this.calendarOptions.events = [
                ...this.calendarOptions.events,
                {
                  id: item._id,
                  title: item.title,
                  start: item.startTime,
                  end: item.endTime,
                  classNames: [item.status, item.lessonType, item.age_bracket, "group"+item.group, "future"]
                }
              ];
            }

            this.updateEvents();

            
          }
        })
        .catch((error) => {
          this.loading = false;

          // eslint-disable-next-line no-console
          console.log(error);
          if (error.response) {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Network/Server Error Please Reload Page and Try Again ",
              type: "error",
            });
          }
        });

      }
    },

    updateLesson() {  
      this.showEditModal = false;
      this.loading = true;
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };

      axios
      .post(
        this.$apiURI + "/classroom/" + this.updatingRoom._id + "/update",
        this.updatingRoom,
        config
      )
      .then((response) => {
        this.loading = false;

        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          console.log("success");

      this.startTime = formatDate(this.updatingRoom.startTime, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',

      });

      this.endTime = formatDate(this.updatingRoom.endTime, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });


          this.showViewModal = true;
          this.updateEvents();
          this.$toast.open({
            message: "Success : " + response.data.data.message,
            type: "success",
          });
        }
      })
      .catch((error) => {
        this.loading = false;

        // eslint-disable-next-line no-console
        console.log(error);
        if (error.response) {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        } else {
          this.$toast.open({
            message: "Network/Server Error Please Reload Page and Try Again ",
            type: "error",
          });
        }
      });

    },

    updateEvents() {
      let currentTime = new Date();

      currentTime = currentTime.getTime();

      for(let item of this.calendarOptions.events) {

        let classItem = this.classroom[item.id];
        item.title = classItem.title;

        let currentStatus = "future";

        let startTimestamp = Date.parse(classItem.startTime);
        let endTimestamp = Date.parse(classItem.endTime);

        if(currentTime >= endTimestamp) {
          currentStatus = "past";
        } else if (currentTime >= startTimestamp && currentTime < endTimestamp) {
          currentStatus = "current";
        } else if (currentTime < startTimestamp && currentTime > startTimestamp - 300000) {
          currentStatus = "ready";
        } else {
          currentStatus = "future";
        }
        item.classNames = [
          classItem.status, classItem.lessonType, classItem.age_bracket, "group"+classItem.group, currentStatus
        ];
        item.start = classItem.startTime;
        item.end = classItem.endTime;
      }
    },

    handleMonthChange(event) {
      if (this.lastStartDate !== event.startStr && this.lastEndDate !== event.endStr) {
        this.lastStartDate = event.startStr;
        this.lastEndDate = event.endStr;

        this.classroom = {};
        this.calendarOptions.events = [];
        this.loading = true;

        const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };

        let startTimestamp = Date.parse(event.startStr);
        let endTimestamp = Date.parse(event.endStr);

        axios
          .get(this.$apiURI + "/classroom/rooms/" 
          + this.fastTeacherId + "/"
          + startTimestamp + "/"
          + endTimestamp, config)
          .then((response) => {
            this.loading = false;
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {

              for (const [key, item] of Object.entries(response.data.data)) {
                console.log(key);
                this.classroom[item._id] = item;
                this.calendarOptions.events = [
                  ...this.calendarOptions.events,
                  {
                    id: item._id,
                    title: item.title,
                    start: item.startTime,
                    end: item.endTime,
                    classNames: [item.status, item.lessonType, item.age_bracket, "group"+item.group, "future"]
                  }
                ];
              }

              this.updateEvents();

              //get classroom classes
            }
          })
          .catch((error) => {
            this.loading = false;
            // eslint-disable-next-line no-console
            console.log(error);
            if (error.response) {
              this.$toast.open({
                message: "Error : " + error.response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Network/Server Error Please Reload Page and Try Again ",
                type: "error",
              });
            }
          });
      }
    },

    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },

    onCancel() {
    },

    onIFrameLoad () {
      // do stuff
      this.$refs.jitsiRef.addEventListener('videoConferenceLeft', this.handleVideoConferenceLeft);

    },

    handleVideoConferenceLeft() {
      this.showMeetModal = false;
    },

    realTimeChecker() {
        this.timer = setInterval(this.updateEvents, 60000);

    }
  },

  beforeRouteLeave (to, from, next) {
    if(this.timer)
        clearInterval(this.timer);
      next();
  },

  mounted() {

    this.realTimeChecker();

  },

  computed: {
    jitsiOptions () {
      return {
        roomName: this.updatingRoom.slug,
        height: 700,
        noSSL: true,
        userInfo: {
          email: '',
          displayName: this.teacherName,
        },
        configOverwrite: {
          enableNoisyMicDetection: false,
          prejoinPageEnabled: false,
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false
        },
        onload: this.onIFrameLoad
      };
    },
  },
};
</script>